import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Page not found</h1>
      <Link to="/" className="text-primary-600 hover:underline">
        Go home
      </Link>
    </div>
  );
}
